import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import Projects from "../components/projects/Projects";

export default function ProjectsPage() {
  return (
    <div className="sections">
      <div className="page-hero">
        <h1 className="page-title">Side quests and experiments.</h1>
        <p className="page-blurb">
          Things I've built outside of my main roles: games, machine learning
          experiments, and developer tooling.
        </p>
        <Link className="back-link" to="/"><ArrowLeft size={14} weight="bold" /> Back home</Link>
      </div>
      <Projects />
    </div>
  );
}
